export default "/fonts/SofiaSans-500-Medium.woff2?2af72115eeb2efd3a595f91958e73e73";